module.exports = __webpack_public_path__ + "static/media/sell.9bd38398.svg";